import axios from "axios";
import env from "variables/config";
import { errorHandler } from "./utils";

axios.defaults.baseURL = env.apiUrl;

const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const getMyProspects = async () => {
    const res = await axios.get(`/prospects?limit=1000`, config()).catch((err: any) => {
        return null;
    });
    if (!res) return null;
    return res.data;
};

/** Every tag on the user's CRM prospects, sorted. */
export const getProspectTags = async (): Promise<string[]> => {
    const res = await axios.get("/prospects/tags", config()).catch(errorHandler);
    return res?.data || [];
};

export const createProspect = async (prospect: any) => {
    const res = await axios.post("/prospects", prospect, config()).catch(errorHandler);
    return res?.data;
};

export const updateProspect = async (id: string, data: any) => {
    const res = await axios.put(`/prospects/${id}`, data, config()).catch(errorHandler);
    return res?.data;
};

export const deleteProspect = async (id: string) => {
    const res = await axios.delete(`/prospects/${id}`, config()).catch(errorHandler);
    return res?.data;
};

export const getProspect = async (id: string) => {
    const res = await axios
        .get(`/prospects/${id}`, config())
        .catch((_err): any => null);
    if (!res) return null;
    return res.data;
};

export const getProspectMonthlyLogs = async (params?: {
    project?: string;
    from?: string; // ISO date
    to?: string;   // ISO date
    types?: string; // comma-separated list
    period?: string; // weekly, monthly, quarterly
}) => {
    const query = new URLSearchParams();
    if (params?.project) query.set("project", params.project);
    if (params?.from) query.set("from", params.from);
    if (params?.to) query.set("to", params.to);
    if (params?.types) query.set("types", params.types);
    if (params?.period) query.set("period", params.period);
    const qs = query.toString();
    const url = `/prospects/stats/monthly-logs${qs ? `?${qs}` : ""}`;
    const res = await axios.get(url, config()).catch((_err): any => null);
    return res?.data || [];
};

export const getProspectsByStatus = async (params?: {
    project?: string;
}) => {
    const query = new URLSearchParams();
    if (params?.project) query.set("project", params.project);
    const qs = query.toString();
    const url = `/prospects/stats/by-status${qs ? `?${qs}` : ""}`;
    const res = await axios.get(url, config()).catch((_err): any => null);
    return res?.data || [];
};

export const getProspectHeatmap = async (params?: {
    project?: string;
    from?: string;
    to?: string;
    types?: string;
}) => {
    const query = new URLSearchParams();
    if (params?.project) query.set("project", params.project);
    if (params?.from) query.set("from", params.from);
    if (params?.to) query.set("to", params.to);
    if (params?.types) query.set("types", params.types);
    const qs = query.toString();
    const url = `/prospects/stats/heatmap${qs ? `?${qs}` : ""}`;
    const res = await axios.get(url, config()).catch((_err): any => null);
    return res?.data || [];
};

export const getReplyRatesByTag = async () => {
    const url = `/prospects/stats/reply-rates-by-tag`;
    const res = await axios.get(url, config()).catch((_err): any => null);
    return res?.data || [];
};
